import './sections.scss';
import SimpleSlider from './Slider';

function SectionItem(props) {
    let SectionList = props.sectionInfo.map ((cart, idx) =>
    {    
        let List = cart.text.map ((list, idx) =>
        {    
            return (
                <li key={idx}>{list.li}</li>
            )
        })
        return ( 
            <div className="cart_content" key={idx}>
                <div className="title md">
                    <b>JVC</b> {cart.title}
                </div>
                <div className={"section " + (cart.className)} id={cart.alt}>
                        <div className="section_desc">
                            <div className="title-desc">
                                <div className="title">
                                    <b>JVC</b> {cart.title}
                                </div>
                                <ul className="text">
                                    {List}
                                </ul>
                            </div>
                            <div className="wrap-price">
                                <div className="wrap-price-color">
                                    <div className="price">
                                        <div className="price-new">
                                        {cart.priceNew}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="wrap-price-btn">
                                    <div className="btn-buy">
                                        <a className="link-buy" href = {cart.href}>
                                            Купить
                                            <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.11286 7.6864C2.20755 6.65717 3.07087 5.86963 4.10445 5.86963H13.8956C14.9291 5.86963 15.7925 6.65717 15.8871 7.6864L16.7991 17.5994C16.907 18.7714 15.9845 19.7827 14.8076 19.7827H3.19245C2.01552 19.7827 1.09304 18.7714 1.20086 17.5994L2.11286 7.6864Z" stroke="white" strokeWidth="2"/>
                                                <path d="M12.8251 5.86956C12.8251 5.86956 11.1121 5.86956 8.99898 5.86956C6.88589 5.86956 5.1729 5.86956 5.1729 5.86956C5.1729 3.18018 6.88589 1 8.99898 1C11.1121 1 12.8251 3.18018 12.8251 5.86956Z" stroke="white" strokeWidth="2"/>
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="btn-watch">
                                        <a className="link-watch" href = "https://youtu.be/Ioe0QpQZWX4">
                                            <p> Смотреть обзор
                                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16 8.26795C17.3333 9.03775 17.3333 10.9623 16 11.7321L4 18.6603C2.66667 19.4301 0.999999 18.4678 0.999999 16.9282L1 3.0718C1 1.5322 2.66667 0.569945 4 1.33975L16 8.26795Z" stroke="#0E0E10" strokeWidth="2" strokeLinejoin="round"/>
                                                </svg>
                                            </p>
                                        </a>
                                    </div>
                                    <div className="btn-read">
                                        <a className="link-read" href = "https://www.pult.ru/articles/naushniki/sekrety-zhivogo-zvuchaniya-portativnykh-naushnikov-jvc/">
                                            <p>
                                            Читать обзор
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 16L16 1M16 1H4M16 1V13" stroke="#0E0E10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            </p>

                                        </a>
                                    </div>
                                </div>
                            </div>
                
                        </div>
            
                <div className="section_pic-slider">
                    <SimpleSlider data = {cart}/>
                </div>
            </div>

            </div>
        )
    });

return (
    <div>{SectionList}</div>
)}
export default SectionItem;